export default interface DepartmentMeasurements {
    groupId: number;
    primaryMeasurementUnit ?: string;
    predictionMeasurementUnit ?: string;
    actualInputMeasurementUnit ?: string;
    calculatedMeasurementUnit ?: string;
    secondaryCalculatedMeasurementUnit ?: string;
}

const requiredParameters = ["primaryMeasurementUnit", "predictionMeasurementUnit", "actualInputMeasurementUnit", "calculatedMeasurementUnit"];
export function validateDepartmentMeasurements(measurements: DepartmentMeasurements | undefined): Map<string, string> | undefined {
    const errors: Map<string, string> = new Map()

    if (!measurements) {
        errors.set("notification", "Measurements are missing.")
        return errors;
    }

    const m = measurements as any;

    for(const property in m) {
        if (!m[property] && requiredParameters.includes(property)) {
            errors.set(property, "The measurement unit is required");
        }
    }

    if (errors.size > 0) {
        errors.set("notification", "Errors in measurements.")
        return errors;
    } else {
        return undefined;
    }
}